(function initThemeGlobals() {
  var dataNode = document.getElementById('theme-globals-data');
  if (!dataNode) return;

  try {
    var data = JSON.parse(dataNode.textContent || '{}');
    window.shopUrl = data.shopUrl;
    window.routes = data.routes || {};
    window.cartStrings = data.cartStrings || {};
    window.variantStrings = data.variantStrings || {};
    window.quickOrderListStrings = data.quickOrderListStrings || {};
    window.accessibilityStrings = data.accessibilityStrings || {};
  } catch (error) {
    console.error('Failed to parse theme globals data', error);
  }
})();
